<template>
  <div class="shouye-img">
    <div class="mian-shouye-img">
      <a-carousel autoplay>
        <img
          v-for="item in filterData"
		  :style="node=='djgzlbt'?'cursor: pointer;':''"
          :key="item.id"
          :src="item.smallImage"
		  @click="jump">
      </a-carousel>
    </div>
  </div>
</template>

<script>
import apiUrls from "@api";
export default {
  data() {
    return {
      flag: false,
      caData: [],
	  filterData:[]
    };
  },
  props: {
    node: {
      type: String,
      default: function () {
        return "sylbt";
      },
    },
    //哪个菜单栏目
    type: {
      type: String,
      default: function () {
        return "home";
      },
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 获取轮播详情
    getData() {
      apiUrls.getList({ node: this.node, page: 0, size: 3 }).then((res) => {
        if (res.rCode == 0) {
          this.caData = res.results.data;
		  this.filterData = this.caData.filter(item=>item.smallImage)
        } else {
          console.log("请求失败");
        }
      });
    },
	jump() {
		if(this.node=='djgzlbt'){
			 window.open(this.caData[0].source, "_blank");
		}
	}
   /* goDetail(id) {
      if (this.type == "news") {
        this.$jumpTo("/workDetail", { id, type: "zx" });
      }
    }, */
  },
};
</script>

<style lang="less" scoped>
.shouye-img {
  display: flex;
  justify-content: center;
}
.mian-shouye-img {
  width: 1200px;
  height: 400px;
  /deep/ .ant-carousel {
    width: 100%;
    height: 100%;
    img {
      width: 1200px;
      height: 400px;
    }
  }
}
</style>